import { withFormsy } from 'formsy-react'
import React, { Component } from 'react'
import { Grid } from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';

class DGMultiCheckBoxGroup extends Component {


    componentDidMount = () => {
        let values = [];
        
        this.props.fields.forEach((field , filedIndex) => {
            if(field.value)
            {
                values.push(field.fieldID.toString())
            }
        })
        if(values.length)
        {
            this.props.setValue(values);
        }
    }

    changeValue = (event , fieldObject) => {
        //const currentValue = this.props.value;

        let values = this.props.value ? [...this.props.value]: [];
        

        if (event.currentTarget.checked) {
            if(_.isEmpty(values)){
                values = [];
            }
            values.push(event.currentTarget.value);
            
        }
        else {
            _.pull(values, event.currentTarget.value);
            fieldObject.value = null;
        }

        if(values.length == 0){
            
            this.props.setValue(null);
            
        }
        else{
            
            this.props.setValue(values);
            
        }
        


    }

    isChecked = (valuesArray , fieldObject) => {
        
            if(_.includes(valuesArray, fieldObject.fieldID.toString()) || fieldObject.value)
            {
            return true;
            }
            return false;
        
    }

    render() {

        const childrenWithProps = React.Children.map(this.props.children, child => {
            // checking isValidElement is the safe way and avoids a typescript error too

            if (React.isValidElement(child)) {
                return React.cloneElement(child);
            }

            return child;
        });
        const fields = this.props.fields;

        return (
            <>
                {/*<div className="ui grid">
                    {childrenWithProps.map(child => {
                        return <div className="eight wide column">{child}</div>
                    })}
                </div>*/}
                <Grid key={`multicheckboxgroup-grid`}>
                    {
                        fields && fields.map((field, fieldIndex) => {
                            return (
                            field.isHidden ? "" :
                            <Grid.Column computer={16} mobile={16} key={`multicheckboxgroup-grid-column-${field.fieldID}`}>
                                <div className={`chkbox-field ${!this.props.isPristine && !this.props.isValid ? 'error' : ''}`} key={`chkbox-field-${field.fieldID}`}>
                                    <label className="checkbox" key={`chkbox-${field.fieldID}`}>

                                        <input type="checkbox" checked={this.isChecked(this.props.value , field)} key={`chkbox-ctrl-${field.fieldID}`} name={this.props.name} onChange={(e) => {this.changeValue(e , field)}} value={field.fieldID} />


                                        <span key={`chkbox-icon-${field.fieldID}`} className="checkbox__icon"></span>
                                        <span key={`chkbox-label-${field.fieldID}`} className="text">{field.name}</span>
                                    </label>
                                </div>
                            </Grid.Column>)
                        })
                    }
                </Grid>

                {
                    !this.props.isPristine && !this.props.isValid &&
                    <div className="error error-checkbox-new" key={`chkbox-error-${this.props.name}`}>
                        {this.props.errorMessage}
                    </div>
                }
            </>
        );
    }
}

DGMultiCheckBoxGroup.propTypes = {
    // Props passed from parent
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            fieldID: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]),
            name: PropTypes.string,
            value: PropTypes.any,
            isHidden: PropTypes.bool
        })
    ),
    children: PropTypes.node,
    name: PropTypes.string,
    errorMessage: PropTypes.string,

    // Injected by withFormsy()
    value: PropTypes.array,
    setValue: PropTypes.func.isRequired,
    isValid: PropTypes.bool,
    isPristine: PropTypes.bool
}

export default withFormsy(DGMultiCheckBoxGroup)
